import { LinePath } from '@visx/shape';
import { scaleLinear } from "@visx/scale";
import { Group } from '@visx/group';
import { extent } from "d3-array";
import { schemeTableau10 } from "d3-scale-chromatic";
import { curveMonotoneX } from "d3-shape";
import { scaleOrdinal } from "@visx/scale";


const MiniLinePlot = ({ plotHeight, plotWidth, yearData,marginForEachSide,surveyAnswers,opacity=0.7 }) => {
    const xExtent = extent(yearData.map(d => d.year));
    const yExtent = extent(yearData.map(d => Object.values(d.responses)).flat());
    const yDomainMin = yExtent[0] - 0.03;
    const yDomainMax = yExtent[1] + 0.03;
    const domain = [yDomainMin, yDomainMax];
    const yScale = scaleLinear({
        domain,
        range: [plotHeight - (marginForEachSide * 2), 0]
    })
    const xScale = scaleLinear({
        domain: xExtent,
        range: [0, plotWidth - (marginForEachSide * 2)]
    });

    const uniqueAnswers = surveyAnswers ? surveyAnswers : [...new Set(yearData.map(d => Object.keys(d.responses)).flat())];
    const colorScale = scaleOrdinal({ domain: uniqueAnswers, range: schemeTableau10 })

    return (
        <Group top={marginForEachSide} left={marginForEachSide}>
            {uniqueAnswers.map(answer => (
                <LinePath
                    key={`${answer}-line-path`}
                    data={yearData}
                    x={d => xScale(d.year) ?? 0}
                    y={d => yScale(d.responses[answer]) ?? 0}
                    curve={curveMonotoneX}
                    stroke={colorScale(answer)}
                    strokeWidth={3}
                    shapeRendering="geometricPrecision"
                    opacity={opacity}
                />
            ))}
        </Group>
    )

}

export default MiniLinePlot;